import { useMemo } from 'react'
import clsx from 'clsx'

import { RaHeading, RaIcon, RaTypography } from '../index.core'

import styles from './ra-navbar-dropdown-section.module.scss'

import { KEYDOWN_EVENTS } from '@/constants/gravity-forms.constants'
import { ICONS } from '@/constants/icons.constants'
import { ThemeMenuSubItem } from '@/typings/index.typings'
import { unescapeHTML } from '@/utilities/helpers/unescape-html.helpers'

interface CurrentMenuProps {
  index: number
  menu: ThemeMenuSubItem
}

export interface RaNavbarDropdownSectionProps {
  menu: ThemeMenuSubItem
  setRenderedMenu: ({ index, menu }: CurrentMenuProps) => void
  currentMenu: ThemeMenuSubItem['link']['title']
  index: number
  count: number
  parent: string
}

const DATA_NAME = 'ra-navbar-dropdown-section'

export const RaNavbarDropdownSection = ({
  menu,
  setRenderedMenu,
  currentMenu,
  index,
  count,
  parent,
}: RaNavbarDropdownSectionProps) => {
  const isActive = useMemo(() => {
    return currentMenu === menu?.link?.title
  }, [currentMenu])

  const handleKeyDown = e => {
    e.preventDefault()
    const nextItem = document.getElementById(
      `dropdownsection-${parent}-${index + 1}`
    )
    const prevItem = document.getElementById(
      `dropdownsection-${parent}-${index - 1}`
    )
    const firstItem = document.getElementById(`dropdownsection-${parent}-${0}`)
    const lastItem = document.getElementById(
      `dropdownsection-${parent}-${count - 1}`
    )

    if (
      e.keyCode === KEYDOWN_EVENTS.ARROW_DOWN ||
      e.keyCode === KEYDOWN_EVENTS.TAB
    ) {
      if (nextItem) {
        nextItem.focus()
      } else if (index + 1 === count) {
        firstItem.focus()
      }
    }
    if (e.keyCode === KEYDOWN_EVENTS.ARROW_UP) {
      if (prevItem) {
        prevItem.focus()
      } else if (index === 0) {
        lastItem.focus()
      }
    }
    if (e.keyCode === KEYDOWN_EVENTS.ARROW_RIGHT) {
      const childSection = document.getElementById(
        `dropdown-child-section-${menu.link.title}`
      )
      if (childSection) {
        const href = childSection.querySelectorAll('a')?.[0]
        if (href) {
          href.focus()
        }
      }
    }
  }

  return (
    <div
      data-name={DATA_NAME}
      id={`dropdownsection-${parent}-${index}`}
      className={clsx(
        styles['ra-navbar-dropdown-section'],
        isActive && styles['ra-navbar-dropdown-section--active']
      )}
      onMouseEnter={() => setRenderedMenu({ menu, index })}
      onFocus={() => setRenderedMenu({ menu, index })}
      onKeyDown={handleKeyDown}
      tabIndex={0}>
      {menu.link?.title && (
        <div className={styles['ra-navbar-dropdown-section__heading']}>
          <RaTypography
            color="dark"
            component="span"
            fontFamily="heading">
            {unescapeHTML(menu.link.title)}
          </RaTypography>
          {isActive && (
            <RaIcon
              icon={ICONS.NAVBAR_UNDERLINE}
              minHeight={0}
              minWidth={175}
            />
          )}
        </div>
      )}
      <RaIcon
        color={'primary'}
        icon={ICONS.CHEVRON_RIGHT}
      />
    </div>
  )
}
